import React from "react";
import { useTranslation } from "react-i18next";

export const ReviewAddress = (props: any) => {
  const { t } = useTranslation();
  const { address } = props || {};
  return (
    <p>
      {t("account.leaseApplication.address")}:{" "}
      {address ? (
        <>
          {address.street}
          {address.city ? `, ${address.city} ` : ""}
          {address.state ? `, ${address.state}` : ""}
          {address.zip ? ` ${address.zip}` : ""}
        </>
      ) : (
        <>
          {t(
            "account.leaseApplication.noAddressProvided",
            "No address provided"
          )}
        </>
      )}
    </p>
  );
};
